const {
  removeClass,
  find,
  next,
  parent,
  siblings,
  hasClass,
  addClass,
} = DOM;

const ProductCard = {
  card: null,
  bindVideo(target) {
    const video = target.closest('[data-aciton="product.card.video"]');

    if (video) {
      Fancybox.show([{
        src: video.dataset.href,
      }]);
    }
  },

  bindValumes(target) {
    const button = target.closest('[data-action="check.button"]');
    if (button && !hasClass(button, 'is_active')) {
      [...siblings(parent(button))].forEach(element => {
        removeClass(find(element, 'button'), 'is_active')
      });
      addClass(button, 'is_active');
    }
  },

  bindAddButton(target) {
    const addButton = target.closest('button[data-action="add.button"]');
    const manageButton = target.closest('button[data-action="get.manage"]');
    if (addButton) {
      addClass(addButton, 'is_hidden');
      removeClass(next(addButton), 'is_hidden');
    }
    if (manageButton) {
      Fancybox.show([{ src: '#madal-contact-manager', type: 'inline' }]);
    }
  },

  bindHandler() {
    document.addEventListener('click', event => {
      //this.bindValumes(event.target);
      //this.bindAddButton(event.target);
      this.bindVideo(event.target);
    })
  },

  init() {
    const root = document.querySelector('[data-selector="product.card"]');
    if (root) {
      this.bindHandler();
    }
  }
}

export default ProductCard;
